import React from 'react';
import { observer } from 'mobx-react';
import { WaterwayInput } from './WaterwayInput/WaterwayInput';
import { WaterwayDesign } from './WaterwayDesign/WaterwayDesign';

interface WDTContentComponentProps {
  title?: string;
  sideNav?: boolean;
  addWDTEdits?: any;
  saveReachEdits?: any;
  resetPEMReachEdits?: any;
  toggleAddWaterwayClicked?: any;
  // triggerReloadInputs?: any;
  retriveFlowCalculationResults?: any;
  getAllReachesByAlignedElementDesignParametersId?: any;
  getNotificationStatus?: any;
  getDesignUiState?: any;
  getWDTContainerDataOnMount?: any;
  clearAiTrainingEdits?: () => void;
}

const WDTContentComponent = (props: WDTContentComponentProps) => {
  return (
    <>
      {props.title === 'Waterway Inputs' ? (
        <WaterwayInput toggleAddWaterwayClicked={props.toggleAddWaterwayClicked}
          // triggerReloadInputs={props.triggerReloadInputs} 
          retriveFlowCalculationResults={props.retriveFlowCalculationResults}
          getAllReachesByAlignedElementDesignParametersId={props.getAllReachesByAlignedElementDesignParametersId}
          getNotificationStatus={props.getNotificationStatus}
          getDesignUiState={props.getDesignUiState}
          getWDTContainerDataOnMount={props.getWDTContainerDataOnMount}
        />
      ) : null}
      {props.title === 'Waterway Design' ? (
        <WaterwayDesign
          addWDTEdits={props.addWDTEdits}
          saveReachEdits={props.saveReachEdits}
          resetPEMReachEdits={props.resetPEMReachEdits}
          toggleAddWaterwayClicked={props.toggleAddWaterwayClicked}
          getNotificationStatus={props.getNotificationStatus}
          getDesignUiState={props.getDesignUiState}
          clearAiTrainingEdits={props.clearAiTrainingEdits}
        />
      ) : null}
      {props.title === 'Results' ? (
        <div className="">
          <h2 tabIndex={0} className="">
            <strong>Results</strong>
          </h2>
        </div>
      ) : null}
    </>
  );
};

export const WDTContent = observer(WDTContentComponent);
